import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDocker, faAws, faPython } from '@fortawesome/free-brands-svg-icons';
import { faServer } from '@fortawesome/free-solid-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "Docker Swarm",
    "Kubernetes (EKS)",
    "Portainer",
    "ArgoCD",
    "Caddy Server"
];

const labelsSecond = [
    "AWS RDS",
    "PostgreSQL",
    "Prometheus",
    "Grafana",
    "Loki"
];

const labelsThird = [
    "Odoo 16",
    "Python 3",
    "Ansible",
    "Terraform",
    "Bash"
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Stack Technologique</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faDocker} size="3x"/>
                    <h3>Conteneurisation & Orchestration</h3>
                    <p>Déploiement complet en conteneurs avec Docker. Orchestration légère via Docker Swarm pour le développement, et haute disponibilité avec Amazon EKS pour la production gérée par ArgoCD GitOps.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faServer} size="3x"/>
                    <h3>Bases de données & Observabilité</h3>
                    <p>Gestion sécurisée des données avec PostgreSQL (managé sur AWS RDS en production). Monitoring complet de l'infrastructure via Prometheus, Dashboards dynamiques avec Grafana, et agrégation des logs via Loki/Promtail.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faPython} size="3x"/>
                    <h3>Application Odoo & IaC</h3>
                    <p>Système ERP Technova SISRH basé sur Odoo 16. L'ensemble de l'infrastructure est défini en tant que code (IaC) via Terraform pour le Cloud AWS, et configuré via Ansible pour le VPS.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;
